export default __webpack_public_path__ + "static/media/limit_80.d5aaea2f.svg";